"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCollectibleId = void 0;
var formatCollectibleId = function (collectibleAddress, collectibleInstanceId) {
    if (collectibleInstanceId && collectibleAddress) {
        return "".concat(collectibleAddress, "_").concat(collectibleInstanceId).toLowerCase();
    }
    return collectibleAddress.toLowerCase();
};
exports.formatCollectibleId = formatCollectibleId;
